import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';


document.querySelectorAll('.calendarBody .icon').forEach(function (elm) {
    let content = elm.closest('li').querySelector('.title').outerHTML;
    content = content.replace('</a>', '<br><br>Click for details</a>');
    tippy(elm, {
        content: content,
        allowHTML: true,
        interactive: true,
    });
});